/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WorkflowTaskErrorDto } from './WorkflowTaskErrorDto';

export type TaskWithErrorsDto = {
  id: string;
  workflowExecutionId: string;
  taskType: string;
  status: TaskWithErrorsDto.status;
  graphileJobId?: string;
  itemIndex?: number;
  payload: Record<string, any>;
  result?: Record<string, any>;
  correlationId: string;
  taskHash?: string;
  sequenceNumber: number;
  /**
   * When task is scheduled to run (null = immediate)
   */
  scheduledFor?: string;
  startedAt: string;
  completedAt?: string;
  errors: Array<WorkflowTaskErrorDto>;
};
export namespace TaskWithErrorsDto {
  export enum status {
    PENDING = 'PENDING',
    DEFERRED = 'DEFERRED',
    RUNNING = 'RUNNING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
  }
}
